export const locale = {
    lang: 'en',
    data: {
        'YOUR_SESSION_EXPIRES_IN':'Your session expires in: '
    }
};